import { CRUDEntity } from "../abstracts/CRUDEntity";

export class Lead extends CRUDEntity {

    constructor(id=null) {

        super();
        this.entityClass = 'lead';
        this.urlRoot = '/leads';
        this.sectionRootUrl = '/leads';
        this.id = id;
    }
}
